module.exports = __webpack_public_path__ + "static/img/__8354.f409f7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8354.jpg
// module id = mTt1
// module chunks = 0